/* global modForm modUtils */
import { addInvocaFallbackToDataLayer, addRequiredQSFieldsToForm, initQuadTransform, initQuadTransformRetry } from '../../../helpers';
/**
 * Init Quinstreet form opts
 */
export function initQSForm() {
	const myResultsPage = modUtils.getModernizeDomain() + '/my/results/';

	modForm.opts.tagIDTest = '203838617'; // Use this if there is no quadlink params
	modForm.opts.tagIDLive = '204673056'; // Use this if there is no quadlink params
	modForm.opts.leadSubmitApi = 'hs/tyPage/matches.jsp';
	modForm.opts.trafficDetailsApi = 'api/TrafficDetails/get';
	modForm.opts.isWirelesssApi = 'api/isWireless';
	modForm.opts.websiteName = window.location.host;
	modForm.opts.resultsPage = modForm.opts.resultsPage ? modForm.opts.resultsPage : myResultsPage;
	modForm.opts.errorRedirectPath = modForm.opts.errorRedirectPath ? modForm.opts.errorRedirectPath : myResultsPage;
	modForm.opts.landingPage = window.location.hostname + window.location.pathname;

	if (!modForm.opts.isPreloaded) {
		modForm.opts.qsParams = modForm.opts.qsParams ? modForm.opts.qsParams : ['CCID', 'CLK', 'QTR'];
		modForm.opts.quadLinkParams = {};
		modForm.opts.quadLinkHasBeenTransformed = false;
		modForm.opts.quadLinkData = {
			WebSiteName: modForm.opts.websiteName,
			quadlink: '',
			defaultQuad: '',
			tagID: ''
		};
	}

	// We check if there's a quad link on the query string
	// If not we get the default link
	if (!modForm.opts.delayQuadTransformation) {
		initQuadTransform(true);
	}

	initQuadTransformRetry();

	addRequiredQSFieldsToForm();

	if (modUtils.getLandingPage().includes('bestcompany')) {
		addInvocaFallbackToDataLayer();
	}
}
